import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersSkillEvaluationStandardSummaryCategoryIndexRequestType,
  ApiManagersSkillEvaluationStandardSummaryCategoryIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersSkillEvaluationStandardSummaryCategoryIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersSkillEvaluationStandardSummaryCategoryIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersSkillEvaluationStandardSummaryCategoryIndexResponseType>(
      "/api/managers/skill_evaluation_standard_summary_categories",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersSkillEvaluationStandardSummaryCategoryIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersSkillEvaluationStandardSummaryCategoriesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersSkillEvaluationStandardSummaryCategoryIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersSkillEvaluationStandardSummaryCategoriesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
